import { useFormAugmentedContext } from '@framework/form';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export interface ITriggerValidationProps {
  initialValues?: any;
}

/**
 * TriggerValidation è un componente che forza la validazione del form
 * al momento del caricamento del componente.
 * Utilizza il trigger di RHF per forzare la validazione
 * e mostrare gli errori di validazione.
 */
export function TriggerValidation(props: ITriggerValidationProps) {
  const { initialValues } = props;
  const { trigger, formState, control } = useFormContext();
  const { submitForm, invalidSubject } = useFormAugmentedContext();
  useEffect(() => {
    setTimeout(() => {
      trigger()
        .then(isValid => {
          if (!isValid) {
            // 1. Utilizziamo la modifica del formState per forzare il rendering
            // di RHF come se ci fosse stato un submit.
            control._subjects.state.next({
              submitCount: control._formState.submitCount + 1,
              isSubmitted: true,
              isSubmitSuccessful: false,
            });

            // 2. Oltre a forzare il submit, aggiorniamo l'`augmentedContext`
            // con gli errori appena rilevati (trigger imposta `_formState.errors`).
            // Questo è necessario per visualizzare il box superiore con gli errori
            // (FormErrorsAlert).
            invalidSubject.next({
              type: 'invalid',
              errors: control._formState.errors,
            });
          }
        })
        .catch(e => {
          console.error('[TriggerValidation] An error occurred', e);
        });
    }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues, trigger]);

  return null;
}
